import * as R from "ramda";

import { Version } from "types/entities";

import resourceOperations, { ReadOptions } from "./resourceOperations";

const operation = resourceOperations({
  basePath: "/api/versions",
  baseKey: ["versions"],
  versioned: false,
});

export const useVersions = (opts: ReadOptions = {}) => operation.useRead<Version[]>(null, opts);
export const useVersion = (number: number, opts: ReadOptions = {}) =>
  useVersions({
    ...opts,
    select: R.find(R.propEq(number, "number")),
  });

export const useCurrentVersion = () =>
  useVersions({
    select: R.pipe(R.find(R.propEq(true, "current")), R.prop("number")),
  });

export const useHeadVersion = () =>
  useVersions({
    select: R.pipe(R.find(R.propEq(true, "head?")), R.prop("number")),
  });
